module.exports = __webpack_public_path__ + "img/112.00dd2db9.jpg";